import { SectionItemsForm } from "../types"

export const RSVP_SURVEY_NO_ID = 14744
export const RSVP_SURVEY_GROUP_ID = 1514

const experienceWorkingCRMOptions = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
]

const coMarketingOpportunitiesOptions = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
]
const hospitalityOperationsConsultingOptions = [
  {
    value: "Restaurant & Hotel Operation Management",
    label: "Restaurant & Hotel Operation Management",
  },
  {
    value: "Pre-Opening Solutions",
    label: "Pre-Opening Solutions",
  },
  {
    value: "Hospitality Solutions",
    label: "Hospitality Solutions",
  },
  {
    value: "Owner Representation",
    label: "Owner Representation",
  },
  {
    value: "Staffing & Recruitment",
    label: "Staffing & Recruitment",
  },
]

const financialBusinessPlanningOptions = [
  {
    value: "Audit & Remediation ",
    label: "Audit & Remediation ",
  },
  {
    value: "Cost Controls",
    label: "Cost Controls",
  },
  {
    value: "Financial & Business Plans",
    label: "Financial & Business Plans",
  }
]

const marketingBrandStrategyOptions = [
  {
    value: "Marketing Strategy",
    label: "Marketing Strategy",
  },
  {
    value: "GTM, Brand, Road Map Analysis",
    label: "GTM, Brand, Road Map Analysis",
  },
  {
    value: "Content Generation",
    label: "Content Generation",
  },
  {
    value: "Community Engagement & Member Acquisition Strategies ",
    label: "Community Engagement & Member Acquisition Strategies ",
  }
]

const franchiseExpansionConsultingOptions = [
  {
    value: "Franchise Consulting",
    label: "Franchise Consulting",
  },
  {
    value: "General Advisory",
    label: "General Advisory",
  }
]

const technologyDigitalStrategyOptions = [
  {
    value: "Digital Strategy & Consulting",
    label: "Digital Strategy & Consulting",
  },
  {
    value: "AI Technologies",
    label: "AI Technologies",
  },
  {
    value: "UI & UX Design",
    label: "UI & UX Design",
  },
  {
    value: "Website & Web Applications",
    label: "Website & Web Applications",
  },
  {
    value: "Mobile Applications",
    label: "Mobile Applications",
  },
]

const projectManagementImplementationOptions = [
  {
    value: "Project and Advisory Services",
    label: "Project and Advisory Services",
  },
  {
    value: "Implementation of Tech",
    label: "Implementation of Tech",
  },
  {
    value: "Migrations",
    label: "Migrations",
  }
]

const customITSolutionsEngineeringOptions = [
  {
    value: "IT Services (networks, solutions)",
    label: "IT Services (networks, solutions)",
  },
  {
    value: "Solutions Engineering",
    label: "Solutions Engineering",
  },
  {
    value: "Power BI Reporting/ Custom Reporting",
    label: "Power BI Reporting/ Custom Reporting",
  },
  {
    value: "Front-End UX Design & Development",
    label: "Front-End UX Design & Development",
  },
  {
    value: "API Integrations",
    label: "API Integrations",
  }
]


export const ERROR_REQUIRED_MESSAGE = "This field is required"

export const companyInformationSectionItems: SectionItemsForm = {
  title: "Company Information",
  items: [
    {
      isFullWidth: false,
      fields: [
        {
          label: "Company Name",
          name: "companyName",
          required: true,
          type: "text",
          placeholder: "Enter your company name",
        },
        {
          label: "Website",
          name: "website",
          required: true,
          type: "text",
          placeholder: "Enter your company website",
        },
      ],
    },
    {
      isFullWidth: false,
      fields: [
        {
          label: "Company Overview",
          name: "companyOverview",
          required: true,
          type: "text",
          placeholder: "Enter a brief overview of your company",
        },
        {
          label: "Primary Contact Name",
          name: "primaryContactName",
          required: true,
          type: "text",
          placeholder: "Enter your name",
        },
      ],
    },
    {
      isFullWidth: false,
      fields: [
        {
          label: "Primary Contact Title",
          name: "primaryContactTitle",
          required: true,
          type: "text",
          placeholder: "Enter your contact title",
        },
        {
          label: "Primary Contact Email",
          name: "primaryContactEmail",
          required: true,
          type: "text",
          placeholder: "Enter your email address",
        },
      ],
    },
    {
      isFullWidth: false,
      fields: [
        {
          label: "Primary Contact Phone Number",
          name: "primaryContactPhone",
          required: true,
          type: "text",
          placeholder: "Enter your phone number",
        },
        {
          label: "Address (Street, City, State, Country)",
          name: "address",
          required: true,
          type: "text",
          placeholder: "Enter your address",
        },
      ],
    },
  ],
}


export const companySpecializationSectionItems: SectionItemsForm = {
  title: "Which services does your company specialize in?",
  items: [
    {
      isFullWidth: true,
      fields: [
        {
          label: "Hospitality & Operations Consulting",
          name: "hospitalityOperationsConsulting",
          required: false,
          type: "checkbox",
          options: hospitalityOperationsConsultingOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Financial & Business Planning",
          name: "financialBusinessPlanning",
          required: false,
          type: "checkbox",
          options: financialBusinessPlanningOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Marketing & Brand Strategy",
          name: "marketingBrandStrategy",
          required: false,
          type: "checkbox",
          options: marketingBrandStrategyOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Franchise & Expansion Consulting",
          name: "franchiseExpansionConsulting",
          required: false,
          type: "checkbox",
          options: franchiseExpansionConsultingOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Technology & Digital Strategy",
          name: "technologyDigitalStrategy",
          required: false,
          type: "checkbox",
          options: technologyDigitalStrategyOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Project Management & Implementation",
          name: "projectManagementImplementation",
          required: false,
          type: "checkbox",
          options: projectManagementImplementationOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Custom IT & Solutions Engineering",
          name: "customITSolutionsEngineering",
          required: false,
          type: "checkbox",
          options: customITSolutionsEngineeringOptions
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Other",
          name: "otherSpecialization",
          required: false,
          type: "text",
          placeholder: "Enter other specialization",
        },
      ],
    },
  ],
}


export const partnershipModelSectionItems: SectionItemsForm = {
  title: "Alignment with Peoplevine's Partnership Model",
  items: [
    {
      isFullWidth: true,
      fields: [
        {
          label: "What excites you most about joining the Peoplevine RSVP Partnership Community?",
          name: "partnershipCommunity",
          required: true,
          type: "text",
          placeholder: "Enter your partnership community",
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Do you have any experience working with CRM platforms or membership management technology? ",
          name: "experienceWorking",
          required: true,
          type: "select",
          placeholder: "Select an option",
          options: experienceWorkingCRMOptions,
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "How do you plan to integrate Peoplevine’s platform into your services to benefit your clients? ",
          name: "integratePVPlatform",
          required: true,
          type: "text",
          placeholder: "Enter your integration plan",
        },
      ],
    },
  ],
}

export const referralAndGrowthStrategySectionItems: SectionItemsForm = {
  title: "Referral and Growth Strategy",
  items: [
    {
      isFullWidth: true,
      fields: [
        {
          label: "How do you plan to leverage the Peoplevine RSVP Partnership Community to drive new client opportunities and referrals?",
          name: "clientOpportunities",
          required: true,
          type: "text",
          placeholder: "Enter your client opportunities",
        },
      ],
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Are you open to co-marketing opportunities with Peoplevine (e.g., joint webinars, case studies, promotional materials)?",
          name: "coMarketingOpportunities",
          required: true,
          type: "select",
          placeholder: "Select an option",
          options: coMarketingOpportunitiesOptions,
        },
      ],
    },
  ]
}

export const additionalInformationSectionItems: SectionItemsForm = {
  title: "Additional Information and References",
  items: [
    {
      isFullWidth: true,
      fields: [
        {
          label: "Please provide any references from past clients in the luxury or membership-driven sectors.",
          name: "referencesPastClients",
          required: true,
          type: "text",
          placeholder: "Enter your references",
        },
      ]
    },
    {
      isFullWidth: true,
      fields: [
        {
          label: "Do you have any additional information you’d like to share with us?",
          name: "additionalInformation",
          required: false,
          type: "text",
          placeholder: "Enter any additional information",
        },
      ]
    }
  ]
}